import * as React from "react";
import styled, { css } from "styled-components";
import { ReadOnlyFormGroup } from "components/common";
import { Well } from "components/bootstrap";
const NewExampleWell = styled(Well)(
  ({ theme }) => css`
    margin-bottom: 5px;
    font-family: ${theme.fonts.family.monospace};
    font-size: ${theme.fonts.size.body};
    white-space: pre-wrap;
    overflow-wrap: break-word;
  `
);
const TeamsNotificationDetails = ({ notification }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Webhook URL", value: notification.config.webhook_url }), /* @__PURE__ */ React.createElement(
  ReadOnlyFormGroup,
  {
    label: "Adaptive Card Template",
    value: /* @__PURE__ */ React.createElement(NewExampleWell, { bsSize: "small" }, notification.config.adaptive_card)
  }
), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Message Backlog Limit", value: notification.config.backlog_size }));
export default TeamsNotificationDetails;
